module.exports = __webpack_public_path__ + "img/activity-bg1.97595bf0.png";